import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'
import { convertCoordinateFromString, convertCoordinateToString } from "../common/utils";
import { appConfig } from "../common/config";

const containerStyle = {
  width: "100%",
  height: "400px",
};

interface ICustomizedGoogleMapProps {
  position: string;
  onPositionChange: (value: string) => void;
}

const CustomizedGoogleMap: React.FC<ICustomizedGoogleMapProps> = ({
  position,
  onPositionChange,
}) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: appConfig.settings.googleMapApiKey,
  })

  const pos = convertCoordinateFromString(position) || appConfig.settings.mapDefaultCoordinate;

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={pos}
      zoom={15}
      onClick={(e) => {
        onPositionChange(convertCoordinateToString(e.latLng?.lat(), e.latLng?.lng()));
      }}
    >
    <Marker
      position={pos}
      draggable={true}
      onDragEnd={(e) => {
        onPositionChange(convertCoordinateToString(e.latLng?.lat(), e.latLng?.lng()));
      }}
    />
  </GoogleMap>
  ) : <>Loading Google Map</>;
};

export default CustomizedGoogleMap;